import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterColumn className="animate-on-scroll slide-up">
            <h3>Florida's Top Site Service & Demolition</h3>
            <p>Professional site clearing and demolition services with over 15 years of experience. We provide quality work with attention to detail and customer satisfaction in Northeast Florida.</p>
            <SocialIcons>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </SocialIcons>
          </FooterColumn>
          
          <FooterColumn className="animate-on-scroll slide-up delay-100">
            <h4>Quick Links</h4>
            <FooterLinks>
              <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Project Gallery</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn className="animate-on-scroll slide-up delay-200">
            <h4>Service Areas</h4>
            <ServiceAreas>
              <li>Crescent City, FL</li>
              <li>Palatka, FL</li>
              <li>Interlachen, FL</li>
              <li>Welaka, FL</li>
              <li>Satsuma, FL</li>
              <li>Putnam County, FL</li>
            </ServiceAreas>
          </FooterColumn>
          
          <FooterColumn className="animate-on-scroll slide-up delay-300">
            <h4>Contact Information</h4>
            <ContactInfo>
              <ContactItem>
                <FaPhone />
                <span>
                  <a href="tel:+13868722144">(386) 872-2144</a><br/>
                  <a href="tel:+15127674123">(512) 767-4123</a>
                </span>
              </ContactItem>
              <ContactItem>
                <FaEnvelope />
                <span><a href="mailto:FLSITESERVICE@GMAIL.COM">FLSITESERVICE@GMAIL.COM</a></span>
              </ContactItem>
              <ContactItem>
                <FaMapMarkerAlt />
                <span>Crescent City, FL 32112<br/>Service-based business – we come to you!</span>
              </ContactItem>
              <ContactItem>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                </svg>
                <span>Monday - Sunday: 24/7</span>
              </ContactItem>
            </ContactInfo>
          </FooterColumn>
        </FooterContent>
        
        <FooterBottom className="animate-on-scroll slide-up delay-400">
          <div>
            <p>&copy; {currentYear} Florida's Top Site Service & Demolition. All Rights Reserved.</p>
          </div>
          <FooterBottomLinks>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
          </FooterBottomLinks>
        </FooterBottom>
        
        <DesignerCredit className="animate-on-scroll slide-up delay-500">
          <a href="https://firstproject-cb091.web.app/" target="_blank" rel="noopener noreferrer">
            Designed and built by Mauricio Guevara
          </a>
        </DesignerCredit>
      </div>
      
      <StructuredData>
        {/* Structured data for Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Florida's Top Site Service & Demolition",
            "image": "https://www.floridastopsite.com/images/logo.jpg",
            "url": "https://www.floridastopsite.com",
            "telephone": "+13868722144",
            "description": "Service-based business – we come to you!",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Crescent City",
              "addressRegion": "FL",
              "postalCode": "32112",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 29.4302,
              "longitude": -81.5118
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "00:00",
              "closes": "24:00"
            },
            "priceRange": "$$",
            "servesCuisine": "Site Clearing and Demolition Services",
            "areaServed": {
              "@type": "State",
              "name": "Florida"
            },
            "sameAs": [
              "https://www.facebook.com/floridastopsite",
              "https://www.instagram.com/floridastopsite",
              "https://twitter.com/floridastopsite"
            ]
          })}
        </script>
      </StructuredData>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background: var(--background-color);
  color: white;
  padding: 6rem 0 0;
  position: relative;
  overflow: hidden;
  border-top: 5px solid var(--primary-color);
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    z-index: 0;
  }
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  position: relative;
  z-index: 1;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  h3, h4 {
    color: var(--accent-color);
    margin-bottom: 2rem;
    font-size: 2rem;
  }

  h3 {
    font-size: 2.4rem;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 2rem;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1.5rem;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
    font-size: 1.8rem;
    transition: var(--transition);
    
    &:hover {
      background-color: var(--primary-color);
      transform: translateY(-3px);
    }
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    margin-bottom: 1.2rem;
    
    a {
      color: rgba(255, 255, 255, 0.8);
      transition: var(--transition);
      
      &:hover {
        color: var(--secondary-color);
        padding-left: 5px;
      }
    }
  }
`;

const ServiceAreas = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    margin-bottom: 1.2rem;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    
    &:before {
      content: '';
      display: inline-block;
      width: 0.8rem;
      height: 0.8rem;
      background-color: var(--primary-color);
      margin-right: 1rem;
      border-radius: 50%;
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  
  svg {
    color: var(--primary-color);
    margin-right: 1.5rem;
    font-size: 1.8rem;
    margin-top: 0.3rem;
  }
  
  span {
    color: rgba(255, 255, 255, 0.8);
    
    a {
      color: rgba(255, 255, 255, 0.8);
      
      &:hover {
        color: var(--primary-color);
      }
    }
  }
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.5rem 0 1.5rem;
  margin-top: 5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  
  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.6);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }
`;

const FooterBottomLinks = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    margin-left: 2rem;
    
    a {
      color: rgba(255, 255, 255, 0.6);
      
      &:hover {
        color: var(--secondary-color);
      }
    }
  }
  
  @media (max-width: 768px) {
    li {
      margin: 0 1rem;
    }
  }
`;

const DesignerCredit = styled.div`
  text-align: center;
  padding: 0 0 2.5rem;
  position: relative;
  z-index: 1;
  
  a {
    font-size: 1.2rem;
    color: var(--accent-color);
    text-decoration: none;
    transition: var(--transition);
    padding: 0.5rem 1rem;
    border-radius: 4px;
    border: 1px solid rgba(255, 140, 0, 0.3);
    background-color: rgba(255, 140, 0, 0.05);
    
    &:hover {
      color: white;
      background-color: var(--primary-color);
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  }
`;

const StructuredData = styled.div`
  display: none;
`;

export default Footer; 